import React from "react";

import "./divider.scss";

type Props = {
    className?: string;
    marginTop?: string;
};

const Divider = ({ className, marginTop }: Props) => (
    <span
        className={`divider mt-${marginTop ? marginTop : "3"} ${className}`}
    />
);

export { Divider };
